import React from 'react';
import { ROIResults } from '../types';
import { formatCurrency } from '../utils/formatters';

interface RevenueProjectionProps {
    results: ROIResults | null;
}

const RevenueProjection: React.FC<RevenueProjectionProps> = ({ results }) => {
    if (!results) {
        return null;
    }

    const {
        bookedAppointments,
        completedAppointments,
        closedClients,
        netNewRevenue,
        retentionRevenue,
        totalRevenue,
        netProfit,
    } = results;

    return (
        <section className="revenue-projection">
            <h2>Monthly Revenue Projection</h2>
            <div className="projection-grid">
                <div className="projection-item">
                    <span className="projection-label">Booked Appointments</span>
                    <span className="projection-value">{Math.round(bookedAppointments).toLocaleString()}</span>
                </div>
                <div className="projection-item">
                    <span className="projection-label">Completed Appointments</span>
                    <span className="projection-value">{Math.round(completedAppointments).toLocaleString()}</span>
                </div>
                <div className="projection-item">
                    <span className="projection-label">Closed Clients</span>
                    <span className="projection-value">{Math.round(closedClients).toLocaleString()}</span>
                </div>
                <div className="projection-item">
                    <span className="projection-label">Net New Revenue</span>
                    <span className="projection-value">{formatCurrency(netNewRevenue)}</span>
                </div>
                <div className="projection-item">
                    <span className="projection-label">Retention Revenue</span>
                    <span className="projection-value">{formatCurrency(retentionRevenue)}</span>
                </div>
                <div className="projection-item total">
                    <span className="projection-label">Total Revenue</span>
                    <span className="projection-value">{formatCurrency(totalRevenue)}</span>
                </div>
                <div className="projection-item total">
                    <span className="projection-label">Net Profit</span>
                    <span className="projection-value">{formatCurrency(netProfit)}</span>
                </div>
            </div>
        </section>
    );
};

export default RevenueProjection;
